<template>
    <modal size="large" @close="$emit('close')">
        <template #header>
            <div>
                <span v-if="type" class="font-weight-bold" style="text-transform: capitalize;">
                    {{ type.split('_').join(' ') }}
                </span>
            </div>
        </template>

        <template #body>
			<div v-if="type === 'confirm'">
				<span>
					{{ label }}
				</span>
			</div>
			<div v-else-if="type === 'input_receipt_number'">
				<div>
					<div>
						<span>
							Set Order <b>#{{ data.order_id }}</b> Receipt Number
						</span>
					</div>
					<div class="form-group mt-4">
						<label>
							<b>Receipt Number</b>
						</label>
						<input
							v-model="receiptNumber"
							class="form-control"
							placeholder="Enter Receipt Number"
						/>
					</div>

					<div v-if="data.shipping.receipt_number" class="mt-4">
						<button class="btn btn-light flex-center mb-2 ml-auto mr-auto" @click="swicth">
							<i class="material-icons icons">
								import_export
							</i>
							Switch
						</button>
					</div>

					<div v-if="data.shipping.receipt_number" class="form-group mt-4">
						<label>
							<b>Cancelled Receipt Number</b>
						</label>
						<input
							v-model="cancelledReceiptNumber"
							class="form-control"
							placeholder="Enter Cancelled Receipt Number"
						/>
					</div>
				</div>
			</div>
            <div v-else>
                <label class="">
                    Update Status
                </label>
                <multiselect v-model="status" track-by="key" label="label" :options="filteredOptionStatus" :option-disabled="isOptionDisabled">
					<template #option="{ option }">
						<!-- Custom option layout -->
						<div class="custom-option">
							<span>{{ option.label }}</span>
						</div>
					</template>
				</multiselect>
            </div>
        </template>

        <template #footer>
            <div class="d-flex justify-content-end">
                <button class="btn btn-light" @click="$emit('close')">
                    Cancel
                </button>
                <button class="btn btn-primary" :disabled="isButtonDisabled" :class="{ 'is-loading': isLoading }" @click="update">
                    Update
                </button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'UpdateStatusModal',
	props: {
		type: {
			type: String,
			default: '',
		},
		data: {
			type: Object,
			default: () => ({}),
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			options: [
				{
					key: 'cancelled',
					disabled: false,
					label: 'Cancelled',
				},
				{
					key: 'pending',
					disabled: true,
					label: 'Pending',
				},
				{
					key: 'processing',
					disabled: false,
					label: 'Processing',
				},
				{
					key: 'delivery',
					disabled: false,
					label: 'Delivery',
				},
				{
					key: 'delivered',
					disabled: false,
					label: 'Delivered/Completed',
				},
			],
			receiptNumber: '',
			cancelledReceiptNumber: '',
			status: '',
		};
	},
	computed: {
		label() {
			let label = `Apakah anda yakin ingin menandai barang sudah di terima dengan OrderId : #${this?.data?.order_id}`;

			if (this.data.status === 'processing') {
				label = `Apakah anda yakin ingin menandai barang sudah terkirim dengan OrderId : #${this?.data?.order_id}`;
			}

			return label;
		},
		isButtonDisabled() {
			if (this.type === 'input_receipt_number') {
				return !this.receiptNumber || this.isLoading;
			}
			return this.isLoading;
		},
		filteredOptionStatus() {
			const data = this.data;
			let options = this.options;
			if (data.payment_status === 'paid') {
				options = this.options.filter(option => option?.key !== 'pending');
			}
			return options;
		},
	},
	mounted() {
		if (this.data) {
			if (this.type === 'input_receipt_number') {
				this.receiptNumber = this.data.shipping?.receipt_number;
				this.cancelledReceiptNumber = this?.data?.shipping?.cancelled_receipt_number;
			}
		}
	},
	methods: {
		update() {
			if (this.type === 'confirm') {
				if (this.data.status === 'processing') {
					this.status = {
						key: 'delivery',
						label: 'Delivery',
					};
				} else {
					this.status = {
						key: 'delivered',
						label: 'Delivered/Completed',
					};
				}
				this.$emit('update', this.status, this.type);
			} else if (this.type === 'input_receipt_number') {
				this.$emit('change-rceipt-number', this.receiptNumber, this.cancelledReceiptNumber);
			} else {
				this.$emit('update', this.status, this.type);
			}
		},
		isOptionDisabled(option) {
			console.log('options');
			return option.disabled; // Disable condition
		},
		swicth() {
			const currentReceiptNumberCopy = duplicateVar(this.receiptNumber);
			const cancelledReceiptNumberCopy = duplicateVar(this.cancelledReceiptNumber);

			this.receiptNumber = cancelledReceiptNumberCopy;
			this.cancelledReceiptNumber = currentReceiptNumberCopy;
		},
	},
};
</script>
